import React, { createContext, useContext, useState } from 'react';
import { type SearchMode } from './types';

type SearchControlContextType = {
  searchMode: SearchMode['mode'];
  setSearchMode: React.Dispatch<React.SetStateAction<SearchMode['mode']>>;
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
};

const SearchControlContext = createContext<
  SearchControlContextType | undefined
>(undefined);

export const SearchControlProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [searchMode, setSearchMode] = useState<SearchMode['mode']>('channel');
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <SearchControlContext.Provider
      value={{ searchMode, setSearchMode, searchTerm, setSearchTerm }}
    >
      {children}
    </SearchControlContext.Provider>
  );
};

export const useSearchControl = () => {
  const context = useContext(SearchControlContext);
  if (!context) {
    throw new Error(
      'useSearchControl must be used within a SearchControlProvider'
    );
  }
  return context;
};
